<template>
  <van-popup
    v-model="visible"
    position="bottom"
    class="bet-dialog-popup"
    overlay-class="bet-dialog-overlay"
    get-container="body"
    :close-on-click-overlay="false"
    round
  >
    <div class="bet-dialog" v-if="match">
      <div class="bet-dialog__title">{{ dialogTitle }}</div>
      <div class="bet-dialog__pick">我猜 {{ chosenTeam }} 胜</div>
      <div class="bet-dialog__cost">
        <span>门票</span><strong>{{ ticketCoin }}</strong><span>默往币</span>
        <span class="bet-dialog__balance">当前余额</span><strong>{{ coinBalance }}</strong>
      </div>
      <button class="bet-dialog__submit" :disabled="submitting" @click="$emit('confirm')">
        {{ submitting ? '提交中...' : '确认竞猜' }}
      </button>
      <button class="bet-dialog__cancel" :disabled="submitting" @click="$emit('cancel')">取消</button>
    </div>
  </van-popup>
</template>

<script>
import { roundLabel, sideTeam } from '../utils'

export default {
  name: 'WorldCupQuizBetDialog',
  props: {
    show: Boolean,
    match: Object,
    side: Number,
    ticketCoin: Number,
    coinBalance: Number,
    submitting: Boolean
  },
  computed: {
    visible: {
      get () {
        return this.show
      },
      set () {}
    },
    chosenTeam () {
      return this.match ? sideTeam(this.match, this.side) : ''
    },
    dialogTitle () {
      const label = this.match ? roundLabel(this.match) : ''
      return label ? `确认竞猜·${label}` : '确认竞猜'
    }
  }
}
</script>

<style scoped lang="scss">
.bet-dialog {
  height: 300px;
  padding: 27px 16px 0;
  box-sizing: border-box;
  color: #804c06;
  background: #fff;
  text-align: center;
  font-family: "PingFang SC", sans-serif;
}

.bet-dialog__title {
  color: #b6b7ba;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.bet-dialog__pick {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 52px;
  margin: 23px auto 0;
  box-sizing: border-box;
  border: 1px solid #ffc12d;
  border-radius: 5px;
  color: #804c06;
  background: #fff4bb;
  box-shadow: 0 5px 20px rgba(0, 0, 0, .05);
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}

.bet-dialog__cost {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 17px;
  color: #1f1f1f;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.bet-dialog__cost strong {
  color: #ffc12d;
  font-weight: 600;
}

.bet-dialog__balance {
  margin-left: 8px;
}

.bet-dialog__submit {
  display: block;
  width: 100%;
  height: 50px;
  margin: 21px auto 0;
  border: 0;
  border-radius: 25px;
  color: #804c06;
  background: linear-gradient(180deg, #ffe648 0%, #ffb65a 100%);
  font-size: 16px;
  font-weight: 600;
  line-height: 50px;
}

.bet-dialog__submit:disabled,
.bet-dialog__cancel:disabled {
  opacity: .6;
}

.bet-dialog__cancel {
  display: block;
  width: 32px;
  height: 22px;
  margin: 12px auto 0;
  padding: 0;
  border: 0;
  color: #b6b7ba;
  background: transparent;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
}
</style>

<style lang="scss">
.bet-dialog-popup.van-popup {
  z-index: 120 !important;
  overflow: hidden;
  background: #fff;
}

.bet-dialog-overlay {
  z-index: 119 !important;
}
</style>
